// Local translations
export const T = {
  en_GB: {
    linkedToAccount: (source: string) => `Linked to account ${source}`,
    linkedToSavingsPlan: (source: string) => `Linked to savings agreement ${source}`,
    accountDescription:
      "This portfolio follows up an existing account — the proposal is compared with the account's current holdings.",
    savingsPlanDescription:
      "This portfolio follows up an existing savings agreement — the proposal replaces the agreement's current content.",
  },
  nb_NO: {
    linkedToAccount: (source: string) => `Koblet til kontoen ${source}`,
    linkedToSavingsPlan: (source: string) => `Koblet til spareavtalen ${source}`,
    accountDescription:
      "Denne porteføljen følger opp en eksisterende konto — forslaget sammenlignes med kontoens nåværende beholdning.",
    savingsPlanDescription:
      "Denne porteføljen følger opp en eksisterende spareavtale — forslaget erstatter avtalens nåværende innhold.",
  },
} as const;
